import { createFretboardFrets } from '@fretgenius/ui';
import { useThemeStore } from '@/features/theme';

// Create the FretboardFrets component using the factory from @fretgenius/ui
export const FretboardFrets = createFretboardFrets({
  G: (props) => <g {...props} />,
  Line: (props) => <line {...props} />,
  useThemeStore,
});
